export default function(o, videoUrl, onTimeUpdate){

  var visible = false

  var nextFrame = function(){

    visible = video.is(':visible')

    if(video[0].currentTime){
      onTimeUpdate(video[0].currentTime)
    }

    requestAnimationFrame(function(){
      if(video.is(':visible') || !visible){
        nextFrame()
      }
    })

  }

  var init = function(){

    video[0].currentTime = 0

    nextFrame()

  }

  var video =
    $('<video>')
    .attr({
      autoplay: true,
      muted: true,
      playsinline: true,
      loop: true,
    })
    .append(
      $('<source>')
      .attr({
        src: videoUrl,
        type: 'video/mp4'
      })
    )
    .contextmenu(function(e){
      e.preventDefault()
      return false
    })

  init()

  return video

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/video/video.js